export default <T extends Record<string, unknown>>({
  allowEmpty,
  alwaysOn,
  basePath,
  component,
  defaultValue,
  formClassName,
  initializeForm,
  input,
  isRequired,
  label,
  limitChoicesToValue,
  locale,
  meta,
  options,
  optionText,
  optionValue,
  source,
  textAlign,
  translate,
  translateChoice,
  ...rest
}: T): typeof rest => rest
